function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { AbstractTransport } from '@central-products/abstract-transport-bus';
import { generateMessageId, publishMessage, subscribeToMessage, unsubscribeFromMessage } from './utils/message';
import { addEventSubscription, addMethodSubscriptions, removeEventSubscription, removeMethodSubscriptions } from './utils/subscriptions';
import { getEventTopic, getRequestTopic, getResponseTopic } from './utils/topic';

var MessageBusTransport = /*#__PURE__*/function (_AbstractTransport) {
  _inherits(MessageBusTransport, _AbstractTransport);

  var _super = _createSuper(MessageBusTransport);

  _createClass(MessageBusTransport, null, [{
    key: "getInstance",
    value: function getInstance() {
      if (!MessageBusTransport.instance) {
        MessageBusTransport.instance = new MessageBusTransport();
      }

      return MessageBusTransport.instance;
    }
  }]);

  function MessageBusTransport() {
    _classCallCheck(this, MessageBusTransport);

    return _super.call(this);
  }

  _createClass(MessageBusTransport, [{
    key: "callMethod",
    value: function callMethod(_ref) {
      var domain = _ref.domain,
          serviceName = _ref.serviceName,
          name = _ref.name,
          payload = _ref.payload;
      var requestTopic = getRequestTopic(domain, serviceName, name);
      var responseTopic = getResponseTopic(domain, serviceName, name);
      var requestId = generateMessageId();

      if (!publishMessage(requestTopic, payload, requestId)) {
        return Promise.reject(new Error("".concat(serviceName, ".").concat(name, " not available")));
      }

      return new Promise(function (resolve, reject) {
        var subscriptionId = subscribeToMessage(responseTopic, function (data) {
          unsubscribeFromMessage(subscriptionId);

          if (data && data.error) {
            reject(data);
          } else {
            resolve(data);
          }
        }, requestId);
      });
    }
  }, {
    key: "onBind",
    value: function onBind(_ref2) {
      var _this = this;

      var domain = _ref2.domain,
          serviceName = _ref2.serviceName,
          methods = _ref2.methods;

      var addSubscriptions = function addSubscriptions() {
        return methods.map(function (_ref3) {
          var methodName = _ref3.name;
          var requestTopic = getRequestTopic(domain, serviceName, methodName);
          var responseTopic = getResponseTopic(domain, serviceName, methodName);
          return subscribeToMessage(requestTopic, function (data, id) {
            var handleCall = function handleCall(resp) {
              return publishMessage(responseTopic, resp.payload, id);
            };

            _get(_getPrototypeOf(MessageBusTransport.prototype), "callMethod", _this).call(_this, {
              serviceName: serviceName,
              name: methodName,
              domain: domain,
              payload: data
            }).then(handleCall).catch(handleCall);
          });
        });
      };

      addMethodSubscriptions(domain, serviceName, addSubscriptions);
    }
  }, {
    key: "onUnbind",
    value: function onUnbind(_ref4) {
      var domain = _ref4.domain,
          serviceName = _ref4.serviceName;
      removeMethodSubscriptions(domain, serviceName, unsubscribeFromMessage);
    }
  }, {
    key: "onEventListenerAdded",
    value: function onEventListenerAdded(domain, serviceName, name) {
      var _this2 = this;

      var eventTopic = getEventTopic(domain, serviceName, name);

      var addSubscription = function addSubscription() {
        return subscribeToMessage(eventTopic, function (data) {
          _get(_getPrototypeOf(MessageBusTransport.prototype), "notifySubscribers", _this2).call(_this2, {
            serviceName: serviceName,
            name: name,
            domain: domain,
            payload: data
          });
        });
      };

      addEventSubscription(eventTopic, addSubscription);
    }
  }, {
    key: "onEventListenerRemoved",
    value: function onEventListenerRemoved(domain, serviceName, name) {
      var eventTopic = getEventTopic(domain, serviceName, name);
      removeEventSubscription(eventTopic, unsubscribeFromMessage);
    }
  }, {
    key: "notifySubscribers",
    value: function notifySubscribers(_ref5) {
      var domain = _ref5.domain,
          serviceName = _ref5.serviceName,
          name = _ref5.name,
          payload = _ref5.payload;
      var eventTopic = getEventTopic(domain, serviceName, name);
      publishMessage(eventTopic, payload);
    }
  }]);

  return MessageBusTransport;
}(AbstractTransport);

MessageBusTransport.instance = void 0;
export { MessageBusTransport as default };
//# sourceMappingURL=MessageBusTransport.js.map